import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import RecordVoiceOverRoundedIcon from '@mui/icons-material/RecordVoiceOverRounded';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import { orchard } from '../../theme';
import CherryFace from '../talk/CherryFace';

const ASK_RU = 'Что мне сегодня проверить и что дать каждому ребёнку?';
const ASK_EN = 'What should I check today and what should I give each child?';
const MOODS = ['happy', 'curious', 'excited', 'happy', 'playful', 'proud'];

/* Dashboard: «Черри подскажет» — the day's advice per child (assistant tool
   today_advice), by voice in «Разговор» or as a chat. */
export default function CherryAdviceCard({ en }) {
  const navigate = useNavigate();
  const [mood, setMood] = useState('happy');
  useEffect(() => {
    let i = 0;
    const t = setInterval(() => {
      i = (i + 1) % MOODS.length;
      setMood(MOODS[i]);
    }, 5200);
    return () => clearInterval(t);
  }, []);
  const q = encodeURIComponent(en ? ASK_EN : ASK_RU);

  return (
    <Box
      data-reveal
      sx={(theme) => ({
        mb: 2.5,
        p: { xs: 1.5, sm: 2 },
        pr: { xs: 1.5, sm: 2.5 },
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 1.25, sm: 2 },
        borderRadius: '22px',
        border: '1px solid',
        borderColor: alpha(
          orchard.cherry,
          theme.palette.mode === 'dark' ? 0.35 : 0.18
        ),
        background:
          theme.palette.mode === 'dark'
            ? `linear-gradient(120deg, ${alpha(orchard.cherryBright, 0.16)} 0%, ${alpha(orchard.nightPanel, 0.9)} 70%)`
            : `linear-gradient(120deg, ${orchard.blossom} 0%, #fff 75%)`,
        overflow: 'hidden',
      })}
    >
      <Box sx={{ flexShrink: 0, width: { xs: 72, sm: 92 } }}>
        <CherryFace emotion={mood} size="100%" />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontFamily: orchard.fontDisplay,
            fontWeight: 600,
            fontSize: { xs: '1rem', sm: '1.1rem' },
          }}
        >
          {en ? 'Cherry’s advice for today' : 'Совет Черри на сегодня'}
        </Typography>
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: { xs: '0.85rem', sm: '0.92rem' },
            mt: 0.25,
          }}
        >
          {en
            ? 'Who to check first, which words, and what to give each child — from their assessments, lessons and absences.'
            : 'Кого проверить первым, какие слова и что дать каждому — по оценкам, урокам и пропускам.'}
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1.25 }}>
          <Button
            size="small"
            variant="contained"
            startIcon={<RecordVoiceOverRoundedIcon />}
            onClick={() => navigate(`/talk?q=${q}&send=1`)}
            sx={{ borderRadius: 999, fontWeight: 700 }}
          >
            {en ? 'Ask by voice' : 'Спросить голосом'}
          </Button>
          <Button
            size="small"
            startIcon={<ForumOutlinedIcon />}
            onClick={() => navigate(`/assistant?q=${q}&send=1`)}
            sx={{ borderRadius: 999, fontWeight: 700 }}
          >
            {en ? 'In the chat' : 'В чате'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
